import React, { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { api } from "@/lib/api";

const DISMISS_KEY = "sakura_promo_dismissed";

/**
 * Shows the strongest active discount code at the top of the site.
 * Auto-hides if no active code, all codes used up, or dismissed by user.
 */
export default function PromoBanner() {
  const [promo, setPromo] = useState(null); // {code, amount_off, min_order_amount, remaining_uses, description}
  const [dismissed, setDismissed] = useState(() => {
    if (typeof window === "undefined") return false;
    return sessionStorage.getItem(DISMISS_KEY) === "1";
  });

  useEffect(() => {
    if (dismissed) return;
    // Public lookup: try a known launch code first; fall back silent if not found
    api.get("/discount/SAKURA10").then(({ data }) => {
      if (data?.valid && data.remaining_uses > 0) setPromo(data);
    }).catch(() => {});
  }, [dismissed]);

  if (!promo || dismissed) return null;

  const minText = promo.min_order_amount > 0 ? ` on orders $${promo.min_order_amount.toFixed(0)}+` : "";

  return (
    <div className="bg-gradient-to-r from-sakura-300 via-sakura-400 to-sakura-300 text-white" data-testid="promo-banner">
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-2.5 flex items-center justify-between gap-4 text-xs sm:text-sm">
        <span className="flex items-center gap-2 font-medium tracking-wide">
          <Sparkles className="h-3.5 w-3.5 shrink-0" />
          <span>
            <b>First 10 customers get ${promo.amount_off.toFixed(0)} off{minText}</b> — use code{" "}
            <span className="font-mono font-bold tracking-wider bg-white/25 rounded-full px-2 py-0.5 ml-0.5">{promo.code}</span>
            <span className="hidden sm:inline text-white/85"> · {promo.remaining_uses} left 💕</span>
          </span>
        </span>
        <button
          onClick={() => { sessionStorage.setItem(DISMISS_KEY, "1"); setDismissed(true); }}
          aria-label="Dismiss"
          className="h-6 w-6 grid place-items-center rounded-full bg-white/20 hover:bg-white/30 transition shrink-0"
          data-testid="promo-dismiss"
        >
          <X className="h-3 w-3" />
        </button>
      </div>
    </div>
  );
}
